(function ($) {
  var topicTiles = $('.topic-tiles');
  var tiles = topicTiles.find('.topic-tile');

  // Check if topicTiles and tiles exist in the DOM
  if (topicTiles.length && tiles.length > 0) {
    topicTiles.find('.topic-tile__link').on('click', function () {
      var $link = $(this);
      var linkText = $link.find('.topic-tile__title').text().trim();

      window.dataLayer = window.dataLayer || [];

      window.dataLayer.push({
        event: 'topic_click',
        page_path: window.location.pathname,
        link_text: linkText,
        link_url: $link.attr('href')
      });
    });
  }
})(jQuery);